import React, { useState, useEffect } from 'react';
import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';
import { Container } from 'react-bootstrap';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';

const ViewEssays = () => {
  const [essays, setEssays] = useState([]);

  useEffect(() => {
    const fetchEssays = async () => {
      try {
        const response = await axios.get('https://backend.writerswright.com/api/v1/teacher/getTeacherEssays');
        setEssays(response.data);
      } catch (error) {
        console.error('Error fetching essays:', error);
      }
    };

    fetchEssays();
  }, []);

  const navigate = useNavigate();

  const navigateToEssayDetails = (essayId) => {
    Cookies.set('essayId', essayId);
    navigate(`/teachers-portal/essays-details-teacher`);
  };

  const sendRequest = async (essayId) => {
    try {
      const response = await axios.post('https://backend.writerswright.com/api/v1/teacher/applyjob', {
        essayId: essayId,
        teacherId: Cookies.get('id'), // Replace with actual teacherId logic
      });
      // Assuming response indicates success, update essays state to reflect change
      setEssays(prevEssays => (
        prevEssays.map(essay => {
          if (essay.essayId === essayId) {
            return { ...essay, status: 'Request Sent' };
          }
          return essay;
        })
      ));
    } catch (error) {
      console.error('Error sending request:', error);
    }
  };

  return (
    <Container>
      <div className="d-flex justify-content-between align-items-center mb-3 alltitles">
        <h2 className="titleone">Available Essays</h2>
      </div>
      <div className="tables">
        <Table bordered>
          <thead>
            <tr>
              <th style={{ color: 'var(--primary)', fontWeight: 'bold' }} className="text">
                Sr
              </th>
              <th style={{ color: 'var(--primary)', fontWeight: 'bold' }} className="text">
                Student
              </th>
              <th style={{ color: 'var(--primary)', fontWeight: 'bold' }} className="text">
                Email
              </th>
              <th style={{ color: 'var(--primary)', fontWeight: 'bold' }} className="text">
                Status
              </th>
              <th style={{ color: 'var(--primary)', fontWeight: 'bold' }} className="text">
                Download
              </th>
              <th style={{ color: 'var(--primary)', fontWeight: 'bold' }} className="text">
                Details
              </th>
              <th style={{ color: 'var(--primary)', fontWeight: 'bold' }} className="text">
                Send Request
              </th>
            </tr>
          </thead>
          <tbody>
            {essays.map((essay, index) => (
              <tr key={essay.essayId}>
                <td>{index + 1}</td>
                <td>{essay.Name} {essay.Surname}</td>
                <td>{essay.Email}</td>
                <td>{essay.Status}</td>
                <td>
                  <a href={`https://backend.writerswright.com/${essay.document}`} style={{ color: 'black' }}>
                    Download Document
                  </a>
                </td>
                <td>
                  <button
                    onClick={() => navigateToEssayDetails(essay.essayId)}
                    style={{ color: 'black', background: 'none', border: 'none', textDecoration: 'underline' }}
                  >
                    View More
                  </button>
                </td>
                <td>
                  {essay.status === null ? (
                    <Link onClick={() => sendRequest(essay.essayId)}>Send</Link>
                  ) : (
                    <span>Request Sent</span>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    </Container>
  );
};

export default ViewEssays;
